import React, { useState } from "react";
import ProgressBar from "./Progress-Bar";
import './Progress-Bar.scss'

function UploadForm() {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);

  const types = ["image/png", "image/jpeg"];

  const handleChange = (e) => {
    let selected = e.target.files[0];

    if (selected && types.includes(selected.type)) {
      setFile(selected);
      setError("");
    } else {
      setFile(null);
      setError("Please select an image file (png or jpg)");
    }

    console.log(selected);
  };

  return (
    <div>

      <form className="uploadform__form" style={{ position: "relative", left: "30%" }}>
        <h3>My Collection</h3>
        <p className='upload__form__para'>Click on this to add your picture</p>
        <label>
          <input type="file" onChange={handleChange} />
          <span style={{ position: "relative", left: "6px" }}>+</span>
        </label>
        <div className="output">
          {error && <div className="error">{error}</div>}
          {file && <div>{file.name}</div>}
          {file && <ProgressBar file={file} setFile={setFile} />}
        </div>
      </form>
    </div>
  );
}

export default UploadForm;
